'use client';

import { useState } from 'react';
import { useWorkflowStore } from '../../../stores/workflowStore';

interface LoadAPIConfigProps {
  nodeId: string;
  config: { url?: string; method?: string; headers?: string; body?: string };
}

export function LoadAPIConfig({ nodeId, config }: LoadAPIConfigProps) {
  const { updateNodeConfig } = useWorkflowStore();
  const [url, setUrl]         = useState(config.url     || '');
  const [method, setMethod]   = useState(config.method  || 'GET');
  const [headers, setHeaders] = useState(config.headers || '');
  const [body, setBody]       = useState(config.body    || '');

  const save = (updates: Partial<typeof config>) => {
    updateNodeConfig(nodeId, { type: 'load_api', params: { url, method, headers, body, ...updates } });
  };

  return (
    <div className="space-y-4">
      <div className="space-y-1.5">
        <label className="text-xs font-medium text-zinc-500">请求地址 (URL)</label>
        <input type="text" placeholder="https://api.example.com/data" value={url}
          onChange={(e) => { setUrl(e.target.value); save({ url: e.target.value }); }}
          className="w-full text-sm bg-white border border-zinc-200 rounded-lg px-3 py-2.5 focus:outline-none focus:ring-2 focus:ring-emerald-500/20 focus:border-emerald-500 placeholder:text-zinc-400"
        />
      </div>
      <div className="space-y-1.5">
        <label className="text-xs font-medium text-zinc-500">请求方法</label>
        <select value={method} onChange={(e) => { setMethod(e.target.value); save({ method: e.target.value }); }}
          className="w-full text-sm bg-white border border-zinc-200 rounded-lg px-3 py-2.5 focus:outline-none focus:ring-2 focus:ring-emerald-500/20 focus:border-emerald-500"
        >
          <option value="GET">GET</option>
          <option value="POST">POST</option>
        </select>
      </div>
      <div className="space-y-1.5">
        <label className="text-xs font-medium text-zinc-500">请求头（JSON 格式，可选）</label>
        <textarea rows={2} placeholder={'{"Authorization": "Bearer token"}'} value={headers}
          onChange={(e) => { setHeaders(e.target.value); save({ headers: e.target.value }); }}
          className="w-full text-sm bg-white border border-zinc-200 rounded-lg px-3 py-2.5 focus:outline-none focus:ring-2 focus:ring-emerald-500/20 focus:border-emerald-500 resize-none font-mono placeholder:text-zinc-400"
        />
      </div>
      {method === 'POST' && (
        <div className="space-y-1.5">
          <label className="text-xs font-medium text-zinc-500">请求体（JSON 格式，可选）</label>
          <textarea rows={3} placeholder='{"key": "value"}' value={body}
            onChange={(e) => { setBody(e.target.value); save({ body: e.target.value }); }}
            className="w-full text-sm bg-white border border-zinc-200 rounded-lg px-3 py-2.5 focus:outline-none focus:ring-2 focus:ring-emerald-500/20 focus:border-emerald-500 resize-none font-mono placeholder:text-zinc-400"
          />
        </div>
      )}
    </div>
  );
}
